/**
 * Arabic catalogue scaffold (P127 / brand P2.11).
 *
 * NOT a real translation -- it's the English catalogue with every string
 * marked as "pending translation" (see `markUntranslated`). It exists so
 * the language switch + `dir="rtl"` mechanism ships today (the layout is
 * already RTL-safe via logical utilities) WITHOUT fabricating Arabic for
 * a SAMA-regulated product.
 *
 * `ar: typeof en` -- the type is identical to the English catalogue, so
 * key-parity is guaranteed by the compiler. To ship real Arabic, a
 * translator replaces this file with a hand-authored object of the same
 * shape (the `typeof en` annotation will flag any missing/extra key).
 */
import { en } from "shared/i18n/en";
import { markUntranslated } from "shared/i18n/markUntranslated";

export const ar: typeof en = markUntranslated(en);
